import {IncidentManager, XDRManager} from "@advthreat/ribbon-components";
import axios from "axios";
import {appConfig} from "config/defaultConfig";
import {APP_SOURCE} from "models/constants";
import {responsePlaybook} from "./responses/mocks/playbookMock";
import {extractXHitsHeader} from "./utils/incidents";

const IROH_SERVICES = appConfig.APP.IROH_SERVICES;
const PRIVATE_INTEL_PROXY = appConfig.APP.PRIVATE_INTEL_PROXY;

export function fetchIncidentById(id) {
  const params = {
    query: `id:(${id})`,
    limit: 1
  };

  return axios
    .get(PRIVATE_INTEL_PROXY.ROUTES.INCIDENT_SEARCH, {params})
    .then((response) => response.data);
}

export function updateIncident(incidentId, patch) {
  const {promise} = IncidentManager.patchIncident(incidentId, patch, {
    notify: false
  });
  return promise;
}

export function fetchIncidentAuditLog({
  shortId,
  sortBy = "timestamp:desc",
  currentPage = 1,
  resultsPerPage = 10
}) {
  return axios
    .get(`${window.CONFIG.privateCtiaHost}:443/ctia/event/search`, {
      params: {
        query: `entity.id:"${window.CONFIG.privateCtiaHost}:443/ctia/incident/${shortId}"`,
        sort_by: "timestamp",
        sort_order: sortBy,
        offset: (currentPage - 1) * resultsPerPage,
        limit: resultsPerPage
      }
    })
    .then((response) => {
      return {
        data: response.data,
        totalLogCount: extractXHitsHeader(response)
      };
    });
}

export function fetchIncidentSummary(id) {
  return axios
    .get(
      `${PRIVATE_INTEL_PROXY.ROUTES.INCIDENT}/${id}${PRIVATE_INTEL_PROXY.ROUTES.SUMMARY}`
    )
    .then((resp) => resp.data);
}

// @todo: Replace with real API call once it exists
export async function fetchIncidentPlaybook() {
  return responsePlaybook;
}

export async function postExecutionWorkflow(payload) {
  const {coaId, incidentId, workflowId, type, values} = payload;
  // Workflows don't accept arrays, must be a comma separated string
  const workflowValues = values?.map((entity) => entity?.value)?.join(", ");

  const workflowVariables =
    !type || !values
      ? {}
      : {
          observable_type: type,
          observable_value: workflowValues
        };

  const resp = await axios.post(
    `${window.CONFIG.apiBaseUri}${IROH_SERVICES.ROUTES.EXECUTE_WORKFLOW}`,
    {
      unique_name: workflowId,
      variables: {
        incident_id: incidentId,
        task_id: coaId,
        ...workflowVariables
      }
    }
  );

  return resp.data;
}

export function fetchIncidentMitreTactics(id) {
  const {promise} = XDRManager.getIncidentTactics(id);
  return promise;
}

export function fetchEventsForIncident(id) {
  return axios
    .get(
      `${PRIVATE_INTEL_PROXY.ROUTES.INCIDENT}/${id}${PRIVATE_INTEL_PROXY.ROUTES.EVENTS}`
    )
    .then((response) => response.data);
}

export async function fetchIncidentNotes({
  shortId,
  sortBy,
  currentPage,
  resultsPerPage
}) {
  const resp = await axios.post(
    `${
      IROH_SERVICES.ROUTES.EVENT_SEARCH
    }?sort_by=created_at&sort_order=${sortBy}&offset=${
      (currentPage - 1) * resultsPerPage
    }&limit=${resultsPerPage}`,
    {
      data: {
        event_type: "private-intel/note/created",
        related_entities: [
          {
            entity_type: "incident",
            entity_id: `${window.CONFIG.privateCtiaHost}:443/ctia/incident/${shortId}`
          }
        ]
      }
    }
  );
  return {
    dataRows: resp.data,
    totalRows: resp.data.paging["total-hits"]
  };
}

export async function postIncidentNote({
  content,
  incidentId,
  additionalEntities = []
}) {
  const resp = await axios.post(`${IROH_SERVICES.ROUTES.NOTE}`, {
    related_entities: [
      {
        entity_id: incidentId,
        entity_type: "incident"
      },
      ...additionalEntities
    ],
    note_class: "default",
    content,
    source: APP_SOURCE
  });

  return resp.data;
}
